angular.module('tasks.meeting-attendance')
    .controller('TaskMeetingAttendanceRejectController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, TaskMeetingAttendance) {
        this.$onInit = () => {
            this.form = {
                id: data.id,
                userId: data.userId,
                action: 'reject'
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return TaskMeetingAttendance.action(this.form).$promise.then(result => {
                $rootScope.$broadcast('task.updated', result);
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        };
    })
